import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';
import { brandAssets, appStoreLinks, socialLinks } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <>
      <footer className="bg-gradient-to-b from-white via-indigo-100/60 to-purple-100/50 dark:from-gray-900 dark:via-indigo-950/40 dark:to-purple-950/30 border-t border-gray-100 dark:border-gray-800 pt-16 pb-8" role="contentinfo">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-10 text-center mb-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1 flex flex-col items-center">
              <img src={brandAssets.logo} alt="Tap In" className="h-8 w-auto mb-4" />
              <p className="text-gray-500 text-sm mb-6">Music. Movement. Moments.</p>
              <div className="flex gap-3">
                <a 
                  href={socialLinks.instagram}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:bg-purple-100 dark:hover:bg-purple-900/50 hover:text-purple-600 transition-colors"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram size={16} />
                </a>
                <a 
                  href={socialLinks.linkedin}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:bg-purple-100 dark:hover:bg-purple-900/50 hover:text-purple-600 transition-colors"
                  aria-label="Follow us on LinkedIn"
                >
                  <Linkedin size={16} />
                </a>
                <div 
                  className="w-9 h-9 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-300 dark:text-gray-500 cursor-not-allowed relative group"
                  title="Coming Soon"
                  aria-label="TikTok - Coming Soon"
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>

            {/* Explore */}
            <div className="flex flex-col items-center">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Explore</h4>
              <ul className="space-y-3">
                <li><Link to="/sessions" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Sessions</Link></li>
                <li><Link to="/playlists" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Playlists</Link></li>
                <li><Link to="/partners" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Partners</Link></li>
                <li><Link to="/pricing" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Pricing</Link></li>
              </ul>
            </div>

            {/* Resources */}
            <div className="flex flex-col items-center">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Resources</h4>
              <ul className="space-y-3">
                <li><Link to="/faq" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">FAQ</Link></li>
                <li><Link to="/status" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Status</Link></li>
                <li><Link to="/privacy" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-gray-600 hover:text-purple-600 text-sm transition-colors">Terms & Conditions</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-200 dark:border-gray-700 pt-8 flex flex-col md:flex-row items-center justify-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Tap In Sound. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
